import {Pipe, PipeTransform} from '@angular/core';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {convertCommercialUnit, TranslateService, Unit} from '@vdw/angular-component-library';

@Pipe({
  name: 'getProductionScheduleItemTotalWovenHeight'
})
export class GetProductionScheduleItemTotalWovenHeightPipe implements PipeTransform {
  public constructor(private translate: TranslateService) {}

  public transform(productionScheduleItem: ProductionScheduleItemInPathGroup, displayTechnicalUnit: boolean, commercialUnit: Unit): string {
    let result: string;

    if (displayTechnicalUnit) {
      result = `${productionScheduleItem.totalWovenHeightInPicks} ${this.translate.instant('GENERAL.UNIT.PICKS')}`;
    } else {
      const unitTranslation = this.translate.instant(`GENERAL.UNIT.${Unit.getKeyFromValue(commercialUnit)}`);

      result = `${convertCommercialUnit({
        from: {
          unit: Unit.MILLIMETER,
          value: productionScheduleItem.totalWovenHeightInMM
        },
        to: commercialUnit
      })} ${unitTranslation}`;
    }

    return result;
  }
}
